module.exports = __webpack_public_path__ + "img/supported-countries.34218f6b.png";